import { gql } from '@apollo/client';

export const GET_SESSIONS = gql`
  query sessions(
    $minUncoveredDuration: Int
    $upsId: String!
    $page: Int
    $limit: Int
    $maxSessionDurationInHours: Int
    $order: String
    $ignoreTerminalState: Boolean
  ) {
    sessions(
      minUncoveredDuration: $minUncoveredDuration
      upsId: $upsId
      page: $page
      limit: $limit
      maxSessionDurationInHours: $maxSessionDurationInHours
      order: $order
      ignoreTerminalState: $ignoreTerminalState
    ) {
      list {
        _id
        endDate
        uncoveredDuration
        previousClaimsForUser
      }
      paging {
        current
        count
      }
    }
  }
`;
